import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'practice-template/:teamId/tagsNotes(/:view)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TagsNotesContainer',
      './modules/tagsNotes'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const TagsNotesContainer = require('./containers/TagsNotesContainer').default
      const actions = require('./modules/tagsNotes')
      const reducer = require('./modules/tagsNotes').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'templateTagsNotes', reducer: reducer })
      
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId, nextState.params.view))

      /*  Return getComponent   */
      cb(null, TagsNotesContainer)

    /* Webpack named bundle   */
    }, 'templateTagsNotes')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CreateTemplate/components/TagsNotesLimitations/index.js